<script>
	import { slugify, watchObject, getObjectField } from "cando-util";
	import { getArticle } from "$lib/utilities/getArticle.js";

	import { translate } from "$lib/utilities/translate";
	import { getActionObject } from "$lib/utilities/getActionObject";
	import { theme } from "$lib/utilities/theme";
	import { getFeatures } from "$lib/utilities/getFeatures";

	import Features from "$lib/components/Features.svelte";

	export let data;
	export let col;
	export let settingId;
	export let preview = false;
	export let lang;
	export let area;

	$: componentSettings = data?.content?.[col]?.[settingId] || {};
	$: watchObject(componentSettings, "componentSettings");

	$: article = getArticle(data?.content, data?.url?.pathname);
	$: fieldMap = componentSettings?.fieldMap?.value;

	const getFieldValue = (doc, fld) => {
		if (article && fieldMap?.[fld]?.value) {
			return getObjectField(article, (fieldMap?.[fld]?.value).split("."));
		}
		return (
			getObjectField(doc, (fieldMap?.[fld]?.value || fld).split(".")) ||
			getObjectField(
				doc?.value,
				(fieldMap?.[fld]?.value || fld).split("."),
			)
		);
	};

	$: bgImage = getFieldValue(componentSettings, "bgImage")?.value;
	$: watchObject(bgImage, "bgImage");
	$: bgImageClass =
		getFieldValue(componentSettings?.classes?.value, "bgImageClass")
			?.value || "";
	$: title = translate(getFieldValue(componentSettings, "title"), lang) || "";
	$: titleClass = getFieldValue(
		componentSettings?.classes?.value,
		"titleClass",
	)?.value;
	$: titleClasses = getFieldValue(
		componentSettings?.classes?.value,
		"titleClasses",
	)?.value;
	$: description =
		translate(getFieldValue(componentSettings, "description"), lang) || "";
	$: descriptionClass = getFieldValue(
		componentSettings?.classes?.value,
		"descriptionClass",
	)?.value;
	$: markedContent =
		translate(getFieldValue(componentSettings, "markedContent"), lang) ||
		"";

	$: featuresContainerClass = getFieldValue(
		componentSettings?.classes?.value,
		"featuresContainerClass",
	)?.value;

	$: features = getFeatures(
		data,
		lang,
		area,
		preview,
		col,
		settingId,
		$theme,
	);
	$: watchObject(features, "features");

	$: bgAltBase =
		getFieldValue(componentSettings, "bgAltBase")?.value === "true"
			? true
			: false;

	$: action = getActionObject(
		data,
		lang,
		area,
		col,
		settingId,
		$theme,
		"action",
	);

	$: contentClass =
		getFieldValue(componentSettings?.classes?.value, "contentClass")
			?.value || "mx-2 sm:mx-4";
	$: daisyuiTheme = getFieldValue(
		componentSettings?.classes?.value,
		"daisyuiTheme",
	)?.value;
	$: elementId = slugify(`${col}-${settingId}`);
</script>

<Features
	{preview}
	{data}
	{bgImage}
	{bgImageClass}
	{bgAltBase}
	{title}
	{titleClass}
	{titleClasses}
	{description}
	{descriptionClass}
	{markedContent}
	{action}
	{contentClass}
	{features}
	{featuresContainerClass}
	{elementId}
	{daisyuiTheme}
/>
